<div class="site-header theme-dark">
  <a routerLink="/dashboard" class="site-header__logo-container" *appFlagExternal>
    <img src="/assets/images/logo-white.svg" class="site-header__logo">
  </a>

  <a routerLink="/explore" class="site-header__logo-container" *appFlagInternal>
    <img src="/assets/images/logo-white.svg" class="site-header__logo">
  </a>

  <div class="site-header__nav" #siteHeader>
    <div class="site-header__item mr-2 ml-2 hide-sm" *appFlagExternal>
      <a routerLink="/dashboard" class="site-header__link" [routerLinkActive]="'site-header__link--active'">Dashboard</a>    
    </div>
    
    <div class="site-header__item mr-3 hide-sm">
      <a
        routerLink="/explore"
        class="site-header__link"
        [routerLinkActive]="'site-header__link--active'" 
        (mouseenter)="handleMenuEnter()"
        (mouseleave)="handleMenuLeave()">Explore <fa-icon icon="caret-down" class="ml-2"></fa-icon></a>

      <app-explore-menu
        *ngIf="exploreShown"
        class="site-header__explore-menu"
        (mouseenter)="handleMenuEnter()"
        (mouseleave)="handleMenuLeave()">
      </app-explore-menu>
    </div>

    <div class="site-header__item">
      <app-search-field></app-search-field>
    </div>
  </div>


  <div class="site-header__account theme-dark">

      <app-locale-menu></app-locale-menu>
      <app-help-menu
        class="ml-1 hide-sm"
        widgetVerticalPosition="bottom"
        widgetHorizontalPosition="right">
      </app-help-menu>
      <app-user-profile-pin class="ml-4 hide-sm"></app-user-profile-pin>
      
  </div>
</div>